import { scrollToElement } from '../base/animate.js';
import Cookie from '../base/cookie.js';
import DataBinding from '../base/data-binding.js';
import { EventHandler } from '../../base/utils.js';
import Form from '../base/form.js';
import { requestUrls } from '../../base/vars.js';
import Spinner from './spinner.js';

class ContactUsForm {
  constructor(elm) {
    this._dropdown = $('#contact-us-select');
    Form.onCountryChange();
    Form.disableFormField('#state0');
    this._form = elm;
    this._formErrorMessages = {};
    if (this._form.length) {
      this.bindFormValidation();
      $(document).on('user:profile:updated', () => {
        this._form.find('#country0').change((e) => $(e.target).trigger('country::updated'));
        Form.displayLockedCountry();
        this.displayMemberNumberFields();
        this.handleZipCodeField();
      });
    }
  }
  bindFormValidation() {
    this._form.formValidation(this.getValidationRequirements())
      .on('status.field.fv', (el, status) => this.handleDepartureDate(status))
      .on('success.form.fv', (e) => this.submitForm(e))
      .on('err.form.fv', () => this.scrollToInputError());
  }
  handleDepartureDate(status) {
    let fields = ['arrivalDay', 'arrivalMonth', 'arrivalYear', 'departureDay', 'departureMonth', 'departureYear'],
      departureDateField = this._form.find('[name=departureDate]'),
      match = '',
      allFields = '';
    allFields = fields.filter((field) => {
      if ($(`[name=${field}]`).val() !== '') {
        return field;
      }
    });
    match = fields.filter((field) => field === status.field);
    if (match && match.length && departureDateField && departureDateField.length && (allFields.length === fields.length)) {
      this._form.formValidation('revalidateField', departureDateField);
    }
  }
  handleZipCodeField() {
    this._form.find('#country0').on('country::updated', (e) => {
      const country = $(e.target);
      if (/^US|CA|MX|GB$/i.test(country.val())) {
        this._form.formValidation('enableFieldValidators', 'zipCode0', true);
      } else {
        this._form.formValidation('enableFieldValidators', 'zipCode0', false);
      }
    })
      .trigger('country::updated');
  }
  getFormErrorMessages() {
    this._formErrorMessages = this._formErrorMessages || {};
    this.addErrorMessage('memberNumber', $('[data-fv-validator="notEmpty"][data-fv-for="memberNumber"]').text());
    this.addErrorMessage('emailAddress', $('[data-fv-validator="notEmpty"][data-fv-for="emailAddress"]').text());
    this.addErrorMessage('emailAddressLength', $('[data-fv-validator="stringLength"][data-fv-for="emailAddress"]').text());
    this.addErrorMessage('emailAddressPattern', $('[data-fv-validator="regexp"][data-fv-for="emailAddress"]').text());
    this.addErrorMessage('firstName', $('[data-fv-validator="notEmpty"][data-fv-for="firstName"]').text());
    this.addErrorMessage('lastName', $('[data-fv-validator="notEmpty"][data-fv-for="lastName"]').text());
    this.addErrorMessage('address1', $('[data-fv-validator="notEmpty"][data-fv-for="address1-0"]').text());
    this.addErrorMessage('country0', $('[data-fv-validator="notEmpty"][data-fv-for="country0"]').text());
    this.addErrorMessage('state0', $('[data-fv-validator="notEmpty"][data-fv-for="state0"]').text());
    this.addErrorMessage('city0', $('[data-fv-validator="notEmpty"][data-fv-for="city0"]').text());
    this.addErrorMessage('phoneNumber0', $('[data-fv-validator="notEmpty"][data-fv-for="phoneNumber0"]').text());
    this.addErrorMessage('zipCode0', $('[data-fv-validator="notEmpty"][data-fv-for="zipCode0"]').text());
    this.addErrorMessage('departureDate', $('[data-fv-validator="notEmpty"][data-fv-for="departureDate"]').text());
  }
  addErrorMessage(selector, value) {
    if (typeof value !== 'undefined' && value) {
      this._formErrorMessages[selector] = value;
    }
  }
  departureAfterArrival(value, validator, $field) {
    let arrivalDate = new Date(`${$('#isoArrivalDate').val()}`),
      departureDate = new Date(`${$('#isoDepartureDate').val()}`);

    if (typeof arrivalDate.getMonth === 'function' &&
      typeof departureDate.getMonth === 'function' &&
      departureDate > arrivalDate) {
      return true;
    }

    return false;
  }
  getValidationRequirements() {
    this.getFormErrorMessages();
    return {
      'live': 'submitted',
      'excluded': [
        ':disabled:not(#isoDepartureDate)',
        ':hidden:not(#isoDepartureDate)',
        ':not(:visible):not(#isoDepartureDate)'
      ],
      'fields': {
        'memberNumber': {
          'validators': {
            'notEmpty': {
              'enabled': true,
              'message': this._formErrorMessages.memberNumber
            },
          }
        },
        'emailAddress': {
          'validators': {
            'notEmpty': {
              'enabled': true,
              'message': this._formErrorMessages.emailAddress
            },
            'stringLength': {
              'min': 6,
              'max': 300,
              'message': this._formErrorMessages.emailAddressLength
            },
            'regexp': {
              'regexp': /^(?!\.)((?!.*\.{2})[a-zA-Z0-9\u0080-\u00FF\u0100-\u017F\u0180-\u024F\u0250-\u02AF\u0300-\u036F\u0370-\u03FF\u0400-\u04FF\u0500-\u052F\u0530-\u058F\u0590-\u05FF\u0600-\u06FF\u0700-\u074F\u0750-\u077F\u0780-\u07BF\u07C0-\u07FF\u0900-\u097F\u0980-\u09FF\u0A00-\u0A7F\u0A80-\u0AFF\u0B00-\u0B7F\u0B80-\u0BFF\u0C00-\u0C7F\u0C80-\u0CFF\u0D00-\u0D7F\u0D80-\u0DFF\u0E00-\u0E7F\u0E80-\u0EFF\u0F00-\u0FFF\u1000-\u109F\u10A0-\u10FF\u1100-\u11FF\u1200-\u137F\u1380-\u139F\u13A0-\u13FF\u1400-\u167F\u1680-\u169F\u16A0-\u16FF\u1700-\u171F\u1720-\u173F\u1740-\u175F\u1760-\u177F\u1780-\u17FF\u1800-\u18AF\u1900-\u194F\u1950-\u197F\u1980-\u19DF\u19E0-\u19FF\u1A00-\u1A1F\u1B00-\u1B7F\u1D00-\u1D7F\u1D80-\u1DBF\u1DC0-\u1DFF\u1E00-\u1EFF\u1F00-\u1FFF\u20D0-\u20FF\u2100-\u214F\u2C00-\u2C5F\u2C60-\u2C7F\u2C80-\u2CFF\u2D00-\u2D2F\u2D30-\u2D7F\u2D80-\u2DDF\u2F00-\u2FDF\u2FF0-\u2FFF\u3040-\u309F\u30A0-\u30FF\u3100-\u312F\u3130-\u318F\u3190-\u319F\u31C0-\u31EF\u31F0-\u31FF\u3200-\u32FF\u3300-\u33FF\u3400-\u4DBF\u4DC0-\u4DFF\u4E00-\u9FFF\uA000-\uA48F\uA490-\uA4CF\uA700-\uA71F\uA800-\uA82F\uA840-\uA87F\uAC00-\uD7AF\uF900-\uFAFF\.!#$%&'*+-/=?^_`{|}~\-\d]+)@(?!\.)([a-zA-Z0-9\u0080-\u00FF\u0100-\u017F\u0180-\u024F\u0250-\u02AF\u0300-\u036F\u0370-\u03FF\u0400-\u04FF\u0500-\u052F\u0530-\u058F\u0590-\u05FF\u0600-\u06FF\u0700-\u074F\u0750-\u077F\u0780-\u07BF\u07C0-\u07FF\u0900-\u097F\u0980-\u09FF\u0A00-\u0A7F\u0A80-\u0AFF\u0B00-\u0B7F\u0B80-\u0BFF\u0C00-\u0C7F\u0C80-\u0CFF\u0D00-\u0D7F\u0D80-\u0DFF\u0E00-\u0E7F\u0E80-\u0EFF\u0F00-\u0FFF\u1000-\u109F\u10A0-\u10FF\u1100-\u11FF\u1200-\u137F\u1380-\u139F\u13A0-\u13FF\u1400-\u167F\u1680-\u169F\u16A0-\u16FF\u1700-\u171F\u1720-\u173F\u1740-\u175F\u1760-\u177F\u1780-\u17FF\u1800-\u18AF\u1900-\u194F\u1950-\u197F\u1980-\u19DF\u19E0-\u19FF\u1A00-\u1A1F\u1B00-\u1B7F\u1D00-\u1D7F\u1D80-\u1DBF\u1DC0-\u1DFF\u1E00-\u1EFF\u1F00-\u1FFF\u20D0-\u20FF\u2100-\u214F\u2C00-\u2C5F\u2C60-\u2C7F\u2C80-\u2CFF\u2D00-\u2D2F\u2D30-\u2D7F\u2D80-\u2DDF\u2F00-\u2FDF\u2FF0-\u2FFF\u3040-\u309F\u30A0-\u30FF\u3100-\u312F\u3130-\u318F\u3190-\u319F\u31C0-\u31EF\u31F0-\u31FF\u3200-\u32FF\u3300-\u33FF\u3400-\u4DBF\u4DC0-\u4DFF\u4E00-\u9FFF\uA000-\uA48F\uA490-\uA4CF\uA700-\uA71F\uA800-\uA82F\uA840-\uA87F\uAC00-\uD7AF\uF900-\uFAFF\-\.\d]+)((\.([a-zA-Z\u0080-\u00FF\u0100-\u017F\u0180-\u024F\u0250-\u02AF\u0300-\u036F\u0370-\u03FF\u0400-\u04FF\u0500-\u052F\u0530-\u058F\u0590-\u05FF\u0600-\u06FF\u0700-\u074F\u0750-\u077F\u0780-\u07BF\u07C0-\u07FF\u0900-\u097F\u0980-\u09FF\u0A00-\u0A7F\u0A80-\u0AFF\u0B00-\u0B7F\u0B80-\u0BFF\u0C00-\u0C7F\u0C80-\u0CFF\u0D00-\u0D7F\u0D80-\u0DFF\u0E00-\u0E7F\u0E80-\u0EFF\u0F00-\u0FFF\u1000-\u109F\u10A0-\u10FF\u1100-\u11FF\u1200-\u137F\u1380-\u139F\u13A0-\u13FF\u1400-\u167F\u1680-\u169F\u16A0-\u16FF\u1700-\u171F\u1720-\u173F\u1740-\u175F\u1760-\u177F\u1780-\u17FF\u1800-\u18AF\u1900-\u194F\u1950-\u197F\u1980-\u19DF\u19E0-\u19FF\u1A00-\u1A1F\u1B00-\u1B7F\u1D00-\u1D7F\u1D80-\u1DBF\u1DC0-\u1DFF\u1E00-\u1EFF\u1F00-\u1FFF\u20D0-\u20FF\u2100-\u214F\u2C00-\u2C5F\u2C60-\u2C7F\u2C80-\u2CFF\u2D00-\u2D2F\u2D30-\u2D7F\u2D80-\u2DDF\u2F00-\u2FDF\u2FF0-\u2FFF\u3040-\u309F\u30A0-\u30FF\u3100-\u312F\u3130-\u318F\u3190-\u319F\u31C0-\u31EF\u31F0-\u31FF\u3200-\u32FF\u3300-\u33FF\u3400-\u4DBF\u4DC0-\u4DFF\u4E00-\u9FFF\uA000-\uA48F\uA490-\uA4CF\uA700-\uA71F\uA800-\uA82F\uA840-\uA87F\uAC00-\uD7AF\uF900-\uFAFF]){2,63})+)$/,
              'message': this._formErrorMessages.emailAddressPattern
            },
          }
        },
        'firstName': {
          'validators': {
            'notEmpty': {
              'enabled': true,
              'message': this._formErrorMessages.firstName
            },
          }
        },
        'lastName': {
          'validators': {
            'notEmpty': {
              'enabled': true,
              'message': this._formErrorMessages.lastName
            },
          }
        },
        'address1-0': {
          'validators': {
            'notEmpty': {
              'enabled': true,
              'message': this._formErrorMessages.address1
            },
          }
        },
        'country0': {
          'validators': {
            'notEmpty': {
              'enabled': true,
              'message': this._formErrorMessages.country0
            },
          }
        },
        'state0': {
          'validators': {
            'notEmpty': {
              'enabled': true,
              'message': this._formErrorMessages.state0
            },
          }
        },
        'city0': {
          'validators': {
            'notEmpty': {
              'enabled': true,
              'message': this._formErrorMessages.city0
            },
          }
        },
        'zipCode0': {
          'validators': {
            'notEmpty': {
              'enabled': true,
              'message': this._formErrorMessages.zipCode0
            },
          }
        },
        'phoneNumber0': {
          'validators': {
            'notEmpty': {
              'enabled': true,
              'message': this._formErrorMessages.phoneNumber0
            },
          }
        },
        'comment': {
          'validators': {
            'notEmpty': {
              'enabled': true,
              'message': $('[data-fv-validator="notEmpty"][data-fv-for="comment"]').text()
            },
          }
        },
        'duplicateMemberNumber': {
          'validators': {
            'notEmpty': {
              'enabled': true,
              'message': $('[data-fv-validator="notEmpty"][data-fv-for="duplicateMemberNumber"]').text()
            },
          }
        },
        'earningPartnerName': {
          'validators': {
            'notEmpty': {
              'enabled': true,
              'message': $('[data-fv-validator="notEmpty"][data-fv-for="earningPartnerName"]').text()
            },
          }
        },
        'rewardName': {
          'validators': {
            'notEmpty': {
              'enabled': true,
              'message': $('[data-fv-validator="notEmpty"][data-fv-for="rewardName"]').text()
            },
          }
        },
        'arrivalDate': {
          'validators': {
            'notEmpty': {
              'enabled': true,
              'message': $('[data-fv-validator="notEmpty"][data-fv-for="arrivalDate"]').text()
            },
          }
        },
        'departureDate': {
          'validators': {
            'callback': {
              'callback': this.departureAfterArrival,
              'message': this._formErrorMessages.departureDate
            }
          }
        },
        'hotelBrand': {
          'validators': {
            'notEmpty': {
              'enabled': true,
              'message': $('[data-fv-validator="notEmpty"][data-fv-for="hotelBrand"]').text()
            },
          }
        },
        'hotelAddress': {
          'validators': {
            'notEmpty': {
              'enabled': true,
              'message': $('[data-fv-validator="notEmpty"][data-fv-for="hotelAddress"]').text()
            },
          }
        },
        'hotelCountry': {
          'validators': {
            'notEmpty': {
              'enabled': true,
              'message': $('[data-fv-validator="notEmpty"][data-fv-for="hotelCountry"]').text()
            },
          }
        },
        'hotelState': {
          'validators': {
            'notEmpty': {
              'enabled': true,
              'message': $('[data-fv-validator="notEmpty"][data-fv-for="hotelState"]').text()
            },
          }
        },
        'hotelCity': {
          'validators': {
            'notEmpty': {
              'enabled': true,
              'message': $('[data-fv-validator="notEmpty"][data-fv-for="hotelCity"]').text()
            },
          }
        },
        'arrivalMonth': {
          'validators': {
            'notEmpty': {
              'enabled': true,
              'message': $('[data-fv-validator="notEmpty"][data-fv-for="arrivalMonth"]').text()
            },
          }
        },
        'arrivalDay': {
          'validators': {
            'notEmpty': {
              'enabled': true,
              'message': $('[data-fv-validator="notEmpty"][data-fv-for="arrivalDay"]').text()
            },
          }
        },
        'arrivalYear': {
          'validators': {
            'notEmpty': {
              'enabled': true,
              'message': $('[data-fv-validator="notEmpty"][data-fv-for="arrivalYear"]').text()
            },
          }
        },
        'departureMonth': {
          'validators': {
            'notEmpty': {
              'enabled': true,
              'message': $('[data-fv-validator="notEmpty"][data-fv-for="departureMonth"]').text()
            },
          }
        },
        'departureDay': {
          'validators': {
            'notEmpty': {
              'enabled': true,
              'message': $('[data-fv-validator="notEmpty"][data-fv-for="departureDay"]').text()
            },
          }
        },
        'departureYear': {
          'validators': {
            'notEmpty': {
              'enabled': true,
              'message': $('[data-fv-validator="notEmpty"][data-fv-for="departureYear"]').text()
            },
          }
        },
      }
    };
  }

  refreshForm() {
    if (this._form.length) {
      this.clearContactUsForm();
      if (typeof User !== 'undefined') {
        DataBinding.renderData(DataBinding.gatherAllData(), '[data-binding]');
      }
      this.bindFormValidation();
      this.displayMemberNumberFields();
      this._form.find('.file-upload')
        .on('click', (e) => this.handleFileUploadClick(e))
        .on('change', '#fileId', () => this.handleFileUpload());
      this._form.find('.file-remove').on('click', (e) => this.resetFileUpload(e));
      Form.disableFormField('#hotelState');
      this._file = '';
      this.handleZipCodeField();
    }
  }
  resetFileUpload(event) {
    event.preventDefault();
    const fileUpload = this._form.find('#fileId');
    fileUpload.replaceWith(fileUpload.val('').clone());
    this._form.find('.file-display').addClass('hidden');
    this._form.find('.file-name').text('');
    this._form.find('.file-upload').removeClass('hidden');
    this.clearFileUploadErrors();
    this.enableForm();
  }
  handleFileUploadClick(event) {
    const href = $(event.target).attr('href');
    if (href && href !== '#') {
      return;
    }
    event.stopPropagation();
    const fileUpload = this._form.find('#fileId');
    if (fileUpload[0] !== event.target) {
      event.preventDefault();
      fileUpload.click();
    }
  }
  clearFileUploadErrors() {
    this._form.find('.file-upload .form-group').removeClass('has-error');
    this._form.find('.file-display .form-group').removeClass('has-error');
    this._form.find('.help-block.file-size').hide();
    this._form.find('.help-block.file-type').hide();
  }
  showFileUploadError(selector) {
    this._form.find('.file-upload .form-group').addClass('has-error');
    this._form.find('.file-display .form-group').addClass('has-error');
    this._form.find(selector).show();
  }
  handleFileUpload() {
    const fileUpload = this._form.find('#fileId')[0];
    const files = fileUpload.files;
    if (files.length > 0) {
      const file = files[0];
      this._form.find('.file-name').text(file.name);
      this._form.find('.file-display').removeClass('hidden');
      this.clearFileUploadErrors();
      if (!this.isValidFileSize(file)) {
        this.showFileUploadError('.help-block.file-size');
        this.disableForm();
      } else if (!this.isValidFileType(file)) {
        this.showFileUploadError('.help-block.file-type');
        this.disableForm();
      } else {
        this._file = file;
        let reader = new FileReader();
        reader.readAsArrayBuffer(this._file);
        reader.onload = function() {
          window.fileData = reader.result;
        };
        this._form.find('.file-upload').addClass('hidden');
        this.enableForm();
      }
    }
  }
  displayMemberNumberFields() {
    const contactType = this._form.find('#contactType').val();
    this._form.find('.member-number').addClass('hidden');
    if (Cookie.isAuthenticated()) {
      this._form.find('.member-locked').removeClass('hidden');
      this._form.find('.member-locked + .flex-form-row').css('border-top', 'none');
    } else {
      if (contactType === 'RQ' || contactType === 'EPQ' || contactType === 'GPQ') {
        this._form.find('.member-select').removeClass('hidden');
        this._form.find('input[name="enrolled"]').on('change', (e) => {
          if ($(e.target).val() === 'true') {
            this._form.formValidation('enableFieldValidators', 'memberNumber', true);
          } else {
            this._form.formValidation('enableFieldValidators', 'memberNumber', false);
          }
        });
      }
      this._form.find('.member-input').removeClass('hidden');
    }
    this._form.find('input[name="enrolled"][value="true"]').prop('checked', true);
    if (this._form.data('formValidation')) {
      this._form.formValidation('enableFieldValidators', 'memberNumber', true);
    }
  }
  disableForm() {
    this._canSubmit = false;
  }
  destroyForm() {
    if (this._form.length) {
      this._form.find('#country0').off('country::updated');
      this._form.formValidation('destroy', true);
    }
  }
  enableForm() {
    this._canSubmit = true;
  }
  submitForm(event) {
    event.preventDefault();
    if (this._canSubmit) {
      this.disableForm();
      Spinner.appendTo(this._form);
      Form.disableFormField('.contact-us-submit');
      let uuid = 'xxxxxxxx-xxxx-yxxx'.replace(/[xy]/g, function(c) {
        var r = Math.random() * 16 | 0, v = c == 'x' ? r : (r & 0x3 | 0x8);
        return v.toString(16);
      });
      if(this._file && this._file.name != undefined ) {
        let $this = this;
        $.ajax({
          type: 'post',
          processData: false,
          contentType: this._file.type,
          data: window.fileData,
          url: requestUrls.wrFileUpload + "?uniq=" + uuid + "&filename=" + this._file.name,
          context: {
            onFail: {
              analyticsEvent: 'contact-us-form_error',
              scrollToElement: this._form,
              formElement: this._form
            }
          }
        }).always(function(jqXHR) {
          if (jqXHR.status === 200) 
            $this.submitContactUsForm(uuid, $this._file.name);
        });
      } else {
        this.submitContactUsForm('','');
      }
    }
  }

  submitContactUsForm(uuid,fileName) {
    let file = {}, sampleForm = {};
    (fileName.length > 0) ? this.createValue(file, 'key', uuid + '/' + fileName) : this.createValue(file, 'key', '');
    sampleForm = {
      'formdata':this.createRequestJSON(Form.serialize(this._form, true)),
      'fileinfo':file
    };
    $.ajax({
      type: 'post',
      url: requestUrls.wrContactUs,
      processData: false,
      data: JSON.stringify(sampleForm),
      cache: false,
      context: {
        onFail: {
          analyticsEvent: 'contact-us-form_error',
          scrollToElement: this._form,
          formElement: this._form
        }
      },
    }).done(() => {
      this.clearContactUsForm();
      Spinner.remove(this._form);
      Form.enableFormField('.contact-us-submit');
      this.submitSuccess();
      this.scrollToForm();
      EventHandler.triggerEvent('contact-us-form_success', {
        formName: this._dropdown.find('option:selected').text()
      });
    }).always(() => {
      this.enableForm();
    });
  }

  submitSuccess() {
    $('.contact-us-form').hide();
    $('.contact-us-success').show();
  }
  clearContactUsForm() {
	$('.form-error').css('display','none');
    $('#contactUs')[0].reset();
    $('#contactUs input,#contactUs .select-container').addClass('empty');
    $('#contactUs #phoneType0').parent().removeClass('empty');
  }
  resetFormView() {
    $('.contact-us-form').show();
    $('.contact-us-success').hide();
  }
  scrollToForm() {
    scrollToElement($('.contact-us-form'));
  }
  scrollToDropdown() {
    scrollToElement($('.select-dropdown-search'), {
      offset: 20
    });
  }
  scrollToInputError() {
    Form.scrollToInputError();
  }
  createRequestJSON(serializedForm) {
    let obj = {};

    if (typeof serializedForm === 'undefined' || !serializedForm) {
      return obj;
    }

    this.createValue(obj, 'memberNumber', serializedForm.memberNumber);
    this.createValue(obj, 'contactType', serializedForm.contactType);
    this.createValue(obj, 'email', serializedForm.emailAddress);
    this.createValue(obj, 'firstName', serializedForm.firstName);
    this.createValue(obj, 'lastName', serializedForm.lastName);
    this.createValue(obj, 'address1', serializedForm['address1-0']);
    this.createValue(obj, 'address2', serializedForm['address2-0']);
    this.createValue(obj, 'address3', serializedForm['address3-0']);
    this.createValue(obj, 'country', serializedForm.country0);
    if (serializedForm.state0) {
      let index = serializedForm.state0.indexOf('_');
      serializedForm.state0 = serializedForm.state0.substr(index + 1);
    }
    this.createValue(obj, 'state', serializedForm.state0);
    this.createValue(obj, 'city', serializedForm.city0);
    this.createValue(obj, 'zipCode', serializedForm.zipCode0);
    this.createValue(obj, 'phone', serializedForm.phoneNumber0);
    this.createValue(obj, 'comment', serializedForm.comment);
    this.createValue(obj, 'duplicateMemberNumber', serializedForm.duplicateMemberNumber);
    this.createValue(obj, 'earningPartnerName', serializedForm.earningPartnerName);
    this.createValue(obj, 'rewardName', serializedForm.rewardName);
    if (serializedForm.contactType === 'RQ' ||
      serializedForm.contactType === 'EPQ' ||
      serializedForm.contactType === 'GPQ') {
      this.createValue(obj, 'enrolled', serializedForm.enrolled);
    }
    this.createValue(obj, 'stayType', serializedForm.stayType);
    this.createSubValue(obj, 'stayDetail', 'arrivalDate', serializedForm.arrivalDate);
    this.createSubValue(obj, 'stayDetail', 'departureDate', serializedForm.departureDate);
    if (serializedForm.hotelBrand) {
      serializedForm.hotelBrand = serializedForm.hotelBrand.toUpperCase();
    }
    this.createSubValue(obj, 'stayDetail', 'brand', serializedForm.hotelBrand);
    this.createSubValue(obj, 'stayDetail', 'address', serializedForm.hotelAddress);
    this.createSubValue(obj, 'stayDetail', 'country', serializedForm.hotelCountry);
    if (serializedForm.hotelState) {
      let index = serializedForm.hotelState.indexOf('_');
      serializedForm.hotelState = serializedForm.hotelState.substr(index + 1);
    }
    this.createSubValue(obj, 'stayDetail', 'state', serializedForm.hotelState);
    this.createSubValue(obj, 'stayDetail', 'city', serializedForm.hotelCity);
    return obj;
  }
  createValue(obj, property, value) {
    if (value) {
      obj[property] = value;
    }
  }
  createSubValue(obj, property, subProperty, value) {
    if (value) {
      obj[property] = obj[property] || {};
      this.createValue(obj[property], subProperty, value);
    }
  }
  isValidFileSize(file) {
    return file.size < 5242880;
  }
  isValidFileType(file) {
    let fileTypes = [
        'application/pdf',
        'image/jpeg',
        'image/png',
        'image/gif',
        'application/vnd.ms-xpsdocument'
      ],
      fileExtensions = [
        /\.pdf$/i,
        /\.jpg$/i,
        /\.png$/i,
        /\.gif$/i,
        /\.xps$/i
      ];

    for (let fileType of fileTypes) {
      if (file.type === fileType) {
        return true;
      }
    }

    for (let fileExtension of fileExtensions) {
      if (fileExtension.test(file.name)) {
        return true;
      }
    }
    return false;
  }
}

export default ContactUsForm;
